import api from '../../utils/api'
import apiSubmissionError from '../../utils/apiSubmissionError'

export const getEmployersApi = (params) => api.get('/managers/engineer_employers', { params })
export const getEmployerByIdApi = (id) => api.get(`/managers/users/${id}`)
export const addEmployerApi = (data) => api.put('managers/associations/accept', data).catch(apiSubmissionError)
